type AppEnvironment = "local" | "staging" | "production";

const BASE_DOMAIN_BY_ENV: Record<AppEnvironment, string> = {
  local: "local.a2z-orders.shop",
  staging: "a2zorders.com",
  production: "trioty.com",
};

function getAppEnvironment(): AppEnvironment {
  const value = import.meta.env.VITE_APP_ENV;
  if (value === "local" || value === "staging" || value === "production") {
    return value;
  }

  return import.meta.env.PROD ? "production" : "local";
}

function getBaseDomain(): string {
  return BASE_DOMAIN_BY_ENV[getAppEnvironment()];
}

function ensureLeadingSlash(path?: string): string {
  if (!path || path === "/") {
    return "";
  }

  return path.startsWith("/") ? path : `/${path}`;
}

function normalizeSlug(storeSlug: string): string {
  return encodeURIComponent(storeSlug);
}

function getBuyerHostname(storeSlug: string): string {
  const slug = normalizeSlug(storeSlug);
  const base = getBaseDomain();
  if (getAppEnvironment() === "staging") {
    return `${slug}-dev.${base}`;
  }
  return `${slug}.${base}`;
}

function getBuyerPath(locale: string, path?: string): string {
  return `/${locale}${ensureLeadingSlash(path)}`;
}

export function getSellerPath(
  locale: string,
  storeSlug: string,
  path?: string,
): string {
  return `/${locale}/${normalizeSlug(storeSlug)}${ensureLeadingSlash(path)}`;
}

export function getBuyerAbsoluteUrl(
  locale: string,
  storeSlug: string,
  path?: string,
): string {
  return `https://${getBuyerHostname(storeSlug)}${getBuyerPath(locale, path)}`;
}
